/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFormBlockCf058Fragment} from '@amblique/contentful/app/contentful/fragments/form-block-cf058/base-form-block-cf058.fragment';
import {BaseEmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/base-embed-panel.fragment';
import {BaseSplitTextFragment} from '@amblique/contentful/app/contentful/fragments/split-text/base-split-text.fragment';

export const FormBlockCf058Fragment = gql`
  ${BaseEmbedPanelFragment}
  ${BaseFormBlockCf058Fragment}
  ${BaseSplitTextFragment}

  fragment FormBlockCf058Fragment on FormBlockCf058 {
    ...BaseFormBlockCf058Fragment

    form {
      ...BaseEmbedPanelFragment
    }
    heading {
      ...BaseSplitTextFragment
    }
  }
`;
